module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "d-event__actions text-dark"
  }, [(_vm.isPossibleToAdd) ? _c('h3', {
    staticClass: "marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.actions_for')) + " \"" + _vm._s(_vm.event.title) + "\"\n    " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards ')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "d-event__actions__action",
    class: {
      'd-event__actions__action--open': _vm.getTheShowAction('remove')
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        return _vm.setTheShowAction('remove')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendar_view_day.remove_onwards')) + "\n      "), _c('svg', {
    staticClass: "tw-icon w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "accordion"
    },
    on: {
      "enter": _vm.start,
      "after-enter": _vm.end,
      "before-leave": _vm.start,
      "after-leave": _vm.end
    }
  }, [(_vm.getTheShowAction('remove')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.do_you_want_to_remove')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')) + ".")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-danger",
    on: {
      "click": function($event) {
        return _vm.openOnwardConfirm('remove')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.remove')) + "\n          " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.isPossibleToAdd) ? _c('li', {
    staticClass: "d-event__actions__action",
    class: {
      'd-event__actions__action--open': _vm.getTheShowAction('add')
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        return _vm.setTheShowAction('add')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendar_view_day.add_onwards')) + "\n      "), _c('svg', {
    staticClass: "tw-icon w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "accordion"
    },
    on: {
      "enter": _vm.start,
      "after-enter": _vm.end,
      "before-leave": _vm.start,
      "after-leave": _vm.end
    }
  }, [(_vm.getTheShowAction('add')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.do_you_want_to_add')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')) + ".")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.openOnwardConfirm('add')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.add')) + " " + _vm._s(_vm.calendar.name) + "\n          " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "d-event__actions__action",
    class: {
      'd-event__actions__action--open': _vm.getTheShowAction('replace')
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        return _vm.setTheShowAction('replace')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.replace_onwards')) + "\n      "), _c('svg', {
    staticClass: "tw-icon w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "accordion"
    },
    on: {
      "enter": _vm.start,
      "after-enter": _vm.end,
      "before-leave": _vm.start,
      "after-leave": _vm.end
    }
  }, [(_vm.getTheShowAction('replace')) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.select_the_person_to_replace')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.with_on_all')) + " \"" + _vm._s(_vm.event.title) + "\"-" + _vm._s(_vm.$t('vue2.calendar_view_day.lessons')) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards_which_include')) + " " + _vm._s(_vm.eventStartFormatted) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.and_all_onwards')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theReplaceWithCalendarId),
      expression: "theReplaceWithCalendarId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.theReplaceWithCalendarId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.select_person')) + "..")]), _vm._v(" "), _vm._l((_vm.selectableCalendars), function(cal) {
    return _c('option', {
      key: cal.id,
      domProps: {
        "value": cal.id
      }
    }, [_vm._v(_vm._s(cal.name))])
  })], 2), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theReplaceWithCalendarId && _vm.theReplaceWithCalendarId !== _vm.calendar.id),
      expression: "theReplaceWithCalendarId && theReplaceWithCalendarId !== calendar.id"
    }],
    on: {
      "click": function($event) {
        return _vm.openOnwardConfirm('replace')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendar_view_day.replace')) + " " + _vm._s(_vm.calendar.name) + " " + _vm._s(_vm.$t('vue2.calendar_view_day.onwards')) + "\n        ")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.onwardConfirmMode) ? _c('CalendarViewDayOnwardConfirm', {
    attrs: {
      "mode": _vm.onwardConfirmMode,
      "calendarName": _vm.calendar.name,
      "minDate": _vm.eventStartDate
    },
    on: {
      "close": function($event) {
        _vm.onwardConfirmMode = null
      },
      "confirm": _vm.onOnwardConfirm
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37033ca5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalendarViewDayRemoveOrReplace.vue
// module id = 1857
// module chunks = 1